export default __webpack_public_path__ + "static/media/0112.22ceed55.jpg";